import { request } from "../utils/request"

/**
 * 根据关键字查询项目列表信息
 * 携带 cmp 企业ID，则查询改企业下的项目，否则查询所有
 * @param params 
 * @returns 
 */
export const searchProjsByName = (params: { keyword: string, cmp?: number | null }) => {
    return request.get('/project/search', { params })
}

/**
 * fetch 项目分页数，返回的数据均关联企业
 * @param params 
 * @returns 
 */
export const getProjs = (params: { cmp?: number, page: number, limit: number }) => {
    return request.get('/project', { params })
}

/**
 * fetch project detail
 * @param params 
 * @returns 
 */
export const getProjDetail = (params: { proj?: number }) => {
    return request.get('/project/detail', { params })
}

/**
 * fetch project types
 * @returns 
 */
export const getProjTypes = () => {
    return request.get('/project/types')
}

/**
 * create 企业关联项目
 * @param cmp 
 * @param data 
 * @returns 
 */
export const createProj = (data: { name: string; location: string; type: number | null; logo: string; pages: string }, cmp?: number) => {
    return request.post(`/project/create/${cmp}`, data)
}

/**
 * update 项目
 * @param data 
 * @returns 
 */
export const updateProj = (data: { id: number, name: string; location: string; type: number | null; logo: string; pages: string }) => {
    return request.post('/project/update', data)
}

/**
 * update project threeD assets
 * @param data 
 * @returns 
 */
export const updateProjThreeAsset = (data: Record<string, Object>, projId?: number) => {
    return request.post(`/project/update/three/assets/${projId}`, data)
}

/**
 * update project Plane assets
 * @param data 
 * @param projId 
 * @returns 
 */
export const updateProjPlaneAsset = (data: Record<string, Object>, projId?: number) => {
    return request.post(`/project/update/plane/assets/${projId}`, data)
}

/**
 * fetch 项目关联的 3d or 2d 资源
 * @param params 
 * @param projId 
 * @returns 
 */
export const getProjMapAsset = (params: { type: 'Model' | 'Image' }, projId?: number) => {
    return request.get(`/project/get/map/assets/${projId}`, { params })
}

/**
 * 获取百度监控地图的项目信息
 * @param params 
 * @returns 
 */
export const getMonitorProjs = (params?: { cmp?: number, proj?: number }) => {
    return request.get(`/project/monitor`, { params })
}


/**
 * fetch company resource
 * @param data 
 * @returns 
 */
export const createProjResource = (data: {
    type: ProjResourceType;
    resource: object
}) => {
    return request.post('/project/create/resource/one', data)
}

/**
 * 项目资源
 * @param params 
 * @returns 
 */
export const getProjResource = (params?: { type: ProjResourceType }) => {
    return request.get('/project/resource', { params })
}

/**
 * update 项目资源
 * @param params 
 * @returns 
 */
export const updateProjResource = (data: {
    id: number,
    resource: object
}) => {
    return request.post('/project/update/resource', data)
}



export enum ProjResourceType {
    Info = "Info", // 简介
    Partner = 'Partner', // 合作伙伴
}